module.exports = __webpack_public_path__ + "static/img/y7.31a2d83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/y7.jpg
// module id = Q5FZ
// module chunks = 1